import { render } from "./why-choose-magnum-dental.vue?vue&type=template&id=a7d671de"
import script from "./why-choose-magnum-dental.vue?vue&type=script&lang=js"
export * from "./why-choose-magnum-dental.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__